"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopLocations = void 0;
const react_1 = __importDefault(require("react"));
const i18n_1 = require("@geome/react-next/lib/hooks/i18n");
const TopLocations = ({ title, subtitle, items }) => {
    const { translate } = (0, i18n_1.useI18n)();
    return (react_1.default.createElement("aside", { className: "top-locations" },
        react_1.default.createElement("h2", { className: "top-locations__title" }, title),
        subtitle && react_1.default.createElement("h3", { className: "top-locations__subtitle" }, subtitle),
        react_1.default.createElement("ul", { className: "top-locations__list" }, items.map(({ name, count, id, link }) => (react_1.default.createElement("li", { className: "top-locations__list-item", key: id },
            react_1.default.createElement("a", { href: link }, translate("sections.top_locations.item", { name, count }))))))));
};
exports.TopLocations = TopLocations;
